import 'slick-carousel';

const $ = window.jQuery;

/**
 * Enables Slick sliders/carousels
 */
const Carousel = {

    /**
     * Initialise functionality
     */
    init()
    {

        this.initInstances($('[data-slick]:not(.slick-initialized)'));

        this.initModalChanges();

        // periodically check when in admin for images to be lazy loaded
        if ($('.block-editor').length) {
            setInterval(() => {
                this.initInstances($('[data-slick]:not(.slick-initialized)'));
            }, 5000);
        }

        // listen to post form changes
        $(window).on('mwb/plugin/post_forms/added_posts', () => {
            this.initInstances($('[data-slick]:not(.slick-initialized)'));
        });

    },

    /**
     * Initialise carousels with their configs stored in data attributes
     *
     * @param {jQuery el} $sliders
     */
    initInstances($sliders)
    {

        let vm = this;

        $sliders.each(function() {
            const $slider = $(this);
            const config = $slider.data('slick');

            // initialise
            $slider.slick(config);

            // add classes from config
            if (config.arrows) {
                $slider.addClass('slick-arrowed');
            }
            if (config.adaptiveHeight) {
                $slider.addClass('slick-adaptive-height');
            }

            // intialise other events/functionality
            vm.initSameHeightSlides($slider);
            vm.initActiveSlideClasses($slider);
            vm.initExternalArrows($slider);
            vm.initExternalCounters($slider);
            vm.initExternalDots($slider);

        });

    },

    /**
     * Ensure slides are the same height
     *
     * @param {jQuery el} $slider
     */
    initSameHeightSlides($slider)
    {

        $slider.on('setPosition', function(e, slick) {

            // cancel if slick has "rows" currently set (same height won't work for
            // these)
            if (slick.$slider.slick('slickGetOption', 'rows') > 1) {
                return;
            }

            // cancel if adaptive height is set
            if (slick.$slider.slick('slickGetOption', 'adaptiveHeight')) {
                return;
            }

            // cancel if vertical is set
            if (slick.$slider.slick('slickGetOption', 'vertical')) {
                return;
            }

            $(slick.$slides).
            height('auto').
            css('height', `${$(slick.$slideTrack).height()}px`);

        });

    },

    /**
     * Apply active & current slide classes stored in data attributes (mainly for
     * Tailwind)
     *
     * @param {jQuery el} $slider
     */
    initActiveSlideClasses($slider)
    {

        $slider.on('setPosition', function(e, slick) {

            const $slides = $(slick.$slides);

            $slides.each(function() {

                const $slide = $(this);

                const isActive = $slide.hasClass('slick-active');
                $slide.find('[data-slick-active]').each(function() {
                    const $el = $(this);
                    const activeClass = $el.data('slick-active');
                    $el.toggleClass(activeClass, isActive);
                });

                const isCurrent = $slide.hasClass('slick-current');
                $slide.find('[data-slick-current]').each(function() {
                    const $el = $(this);
                    const currentClass = $el.data('slick-current');
                    $el.toggleClass(currentClass, isCurrent);
                });

            });

        });

    },

    /**
     * Setup external slick arrows that have been requested via data attributes
     *
     * @param {jQuery el} $slider
     */
    initExternalArrows($slider)
    {

        const prevArrowSelector = $slider.data('slick-arrow-prev') || false;
        const $prevArrows = prevArrowSelector ? $(prevArrowSelector) : false;
        const hasPrevArrows = $prevArrows && $prevArrows.length;

        const nextArrowSelector = $slider.data('slick-arrow-next') || false;
        const $nextArrows = nextArrowSelector ? $(nextArrowSelector) : false;
        const hasNextArrows = $nextArrows && $nextArrows.length;

        // Click listeners
        if (hasPrevArrows) {
            $prevArrows.on('click', () => $slider.slick('slickPrev'));
        }
        if (hasNextArrows) {
            $nextArrows.on('click', () => $slider.slick('slickNext'));
        }

        // Enable / disable custom slick arrows
        $slider.on('setPosition', function(e, slick) {

            let enablePrevArrow = true;
            let enableNextArrow = true;

            if (!slick.options.infinite) {
                if (slick.slideCount > slick.options.slidesToShow) {
                    if (slick.currentSlide === 0) {
                        enablePrevArrow = false;
                        enableNextArrow = true;
                    } else {
                        if (slick.currentSlide >= slick.slideCount -
                            slick.options.slidesToShow && slick.options.centerMode === false) {
                            enablePrevArrow = true;
                            enableNextArrow = false;
                        } else {
                            if (slick.currentSlide >= slick.slideCount - 1 &&
                                slick.options.centerMode === true) {
                                enablePrevArrow = true;
                                enableNextArrow = false;
                            }
                        }
                    }
                } else {
                    // Not enough slides to traverse carousel
                    enablePrevArrow = false;
                    enableNextArrow = false;
                }
            } else {
                if (slick.slideCount <= slick.options.slidesToScroll) {
                    // Even when infinite is enabled and there aren't enough slides,
                    // carousel cannot be traversed
                    enablePrevArrow = false;
                    enableNextArrow = false;
                }
            }

            if (hasPrevArrows) {
                $prevArrows.attr('aria-disabled', enablePrevArrow ? 'false' : 'true');

                if (!enablePrevArrow) {
                    $prevArrows.blur();
                } // in case user is currently 'on' this button & no longer can be

                // Maybe apply disabled class
                $prevArrows.each(function() {
                    const $prevArrow = $(this);
                    const disabledClass = $prevArrow.data('slick-arrow-disabled') || '';
                    $prevArrow.toggleClass(disabledClass, !enablePrevArrow);

                });
            }

            if (hasNextArrows) {
                $nextArrows.attr('aria-disabled', enableNextArrow ? 'false' : 'true');

                if (!enableNextArrow) {
                    $nextArrows.blur();
                } // in case user is currently 'on' this button & no longer can be

                // Maybe apply disabled class
                $nextArrows.each(function() {
                    const $nextArrow = $(this);
                    const disabledClass = $nextArrow.data('slick-arrow-disabled') || '';
                    $nextArrow.toggleClass(disabledClass, !enableNextArrow);

                });
            }

        });

    },

    /**
     * Setup external slick counters that have been requested via data attributes
     *
     * @param {jQuery el} $slider
     */
    initExternalCounters($slider)
    {

        const countersSelector = $slider.data('slick-counters') || false;
        const $counters = countersSelector ? $(countersSelector) : false;
        const hasCounters = $counters && $counters.length;

        if (!hasCounters) {
            return;
        }

        // On change, update slick progress counters
        $slider.on('setPosition', function(e, slick) {
            const current = Math.floor(
                slick.currentSlide / slick.options.slidesToScroll) + 1;
            const total = slick.getDotCount() + 1;

            // Update display
            $counters.each(function() {
                const $counter = $(this);
                $counter.find('[data-slick-counter-current]').text(current);
                $counter.find('[data-slick-counter-total]').text(total);
            });

        });

    },

    /**
     * Setup external slick dots that have been requested via data attributes
     *
     * @param {jQuery el} $slider
     */
    initExternalDots($slider)
    {

        const dotsSelector = $slider.data('slick-dots') || false;
        const $dots = dotsSelector ? $(dotsSelector) : false;
        const hasDots = $dots && $dots.length;

        if (!hasDots) {
            return;
        }

        $dots.html(''); // empty containers for population

        // On change, update slick dot classes
        $slider.on('setPosition', function(e, slick) {
            const current = Math.floor(
                slick.currentSlide / slick.options.slidesToScroll) + 1;
            const total = slick.getDotCount() + 1;

            // Update display
            $dots.each(function() {
                const $dotContainer = $(this);
                const dotClass = $dotContainer.data('slick-dot') || '';
                const activeDotClass = $dotContainer.data('slick-dot-active') || '';
                const inactiveDotClass = $dotContainer.data('slick-dot-inactive') || '';

                const $items = $dotContainer.find('li');

                // Apply accessibility attribute(s)
                $dotContainer.attr('role', 'tab');

                // Populate dots if not done so already already
                if (!$items.length) {

                    for (let index = 0; index < total; index++) {

                        // Generate dot element
                        let _dotClass = dotClass;
                        if (index === 0) {
                            _dotClass += ` ${activeDotClass}`;
                        } else {
                            _dotClass += ` ${inactiveDotClass}`;
                        }

                        const $dot = $(`
                            <li role="presentation">
                                <button
                                    role="tab"
                                    tabindex="-1"
                                    aria-label="${index} of ${total}"
                                    class="${_dotClass}"
                                >
                                    ${index}
                                </button>
                            </li>
                        `);

                        $dot.find('button').
                        on('click', () => $slider.slick('slickGoTo', index));

                        $dotContainer.append($dot);

                    }

                } else {

                    // Indicate currently active dot
                    $items.each(function(index) {
                        const $item = $(this);
                        const isActive = index + 1 === current;

                        // Update display
                        $item.find('button').toggleClass(activeDotClass, isActive);
                        $item.find('button').toggleClass(inactiveDotClass, !isActive);
                    });

                }

            });

        });

    },

    /**
     * Listen to modal changes
     */
    initModalChanges()
    {

        const vm = this;

        $(window).on('modal-change', (e) => {

            const modalId = e.detail;
            if (modalId === false) {
                return;
            }

            setTimeout(() => {
                const $modal = $(`.modal-container[data-modal-id="${modalId}"]`);
                $modal.find('[data-slick]').slick('destroy');
                vm.initInstances($modal.find('[data-slick]:not(.slick-initialized)'));
            }, 100);

        });

    },

};

export default Carousel;